import * as React from "react";

import DetailsTitle from '../CustomeComponents/DetailsTitle';
import Section from "./Section";
import TableList from "./TableList";

const TikimList = (props) => {

  return (
    <div className="container my-3 my-lg-5">
      <DetailsTitle />

      <Section icon={'folder-small'} title={'תיקים'} className="mt-3">
        <TableList tikData={props.tikData}/>
      </Section>
    </div>
  );
}

export default TikimList;